import { ImagePuzzleGameModel } from './image-puzzle-game.model';

export class InitImagePuzzleGame {
  static readonly type = '[ImagePuzzleGame] Init';
  constructor(public payload: ImagePuzzleGameModel) {}
}

export class PersistImagePuzzleState {
  static readonly type = '[ImagePuzzleGame] Persist game state';
  constructor(public payload: ImagePuzzleGameModel) {}
}
